export interface draftDto {
	id?: number;
	xmlBase64?: string;
}

export interface NCASignDto {
	module: string;
	method: string;
	args: {
		allowedStorages: string[];
		format: "xml" | "cms";
		data: string;
		signingParams: {
			decode: boolean;
			encapsulate: boolean;
			digested: boolean;
			tsaProfile: any | null;
		},
		signerParams: {
			extKeyUsageOids: string[];
			iin: string;
			bin: string;
			serialNumber: string;
			chain: string[];
		},
		locale: "ru" | "kk";
	};
}

export interface NCASignResponseDto {
	result?: {
		version?: string;
	};
	body?: {
		result?: string[];
	},
	status?: boolean;
}

export const nCASign: NCASignDto = {
    module: "kz.gov.pki.knca.basics",
    method: "sign",
    args: {
        allowedStorages: [
            "AKKaztokenStore",
            "AKKZIDCardStore",
            "AKEToken72KStore",
            "AKEToken5110Store",
            "AKJaCartaStore",
            "PKCS12",
            "JKS",
            "AKAKEYStore"
        ],
        format: "cms",
        data: "AKEToken5110Store",
        signingParams: {
            decode: true,
            encapsulate: false,
            digested: false,
            tsaProfile: null
        },
        signerParams: {
            extKeyUsageOids: [
                "1.3.6.1.5.5.7.3.4"
            ],
            iin: "",
            bin: "",
            serialNumber: "",
            chain: []
        },
        locale: "ru"
    }
}

export const testSerts: string[] = [
    "-----BEGIN CERTIFICATE-----\nMIIDdjCCAt6gAwIBAgIUJ9Ord5A3LltpgXDd5gzMo4vDpLIwDgYKKoMOAwoBAQID\nAgUAMF8xUDBOBgNVBAMMR9Cd0JXQk9CG0JfQk9CGINCa0KPTmNCb0JDQndCU0KvQ\noNCj0KjQqyDQntCg0KLQkNCb0KvSmiAoR09TVCkgVEVTVCAyMDIyMQswCQYDVQQG\nEwJLWjAeFw0yMjA3MDcwOTA1NTJaFw0zMjA3MDcwOTA1NTJaMF8xUDBOBgNVBAMM\nR9Cd0JXQk9CG0JfQk9CGINCa0KPTmNCb0JDQndCU0KvQoNCj0KjQqyDQntCg0KLQ\nkNCb0KvSmiAoR09TVCkgVEVTVCAyMDIyMQswCQYDVQQGEwJLWjCBrDAjBgkqgw4D\nCgEBAgIwFgYKKoMOAwoBAQICAQYIKoMOAwoBAwMDgYQABIGATv6Hsp7ufinD61Z+\n1mciaCvMzH42Jmnw3WzBUsAkQb7VWSEs8MVmfOtxndhtqhLini6jQESaB/9Ljkxn\nG2+o5PymKeKh4MagxBpZM9bpJ5CEHdfl4ZegjZ8NHL5ccyIspHNgDYGPzaO3VxAu\nV5/cxskOj5+T+Ws0cE7qb+4OiVejggEeMIIBGjAPBgNVHRMBAf8EBTADAQH/MA4G\nA1UdDwEB/wQEAwIBBjAdBgNVHQ4EFgQUp9Ord5A3LltpgXDd5gzMo4vDpLIwgZwG\nA1UdIwSBlDCBkYAUp9Ord5A3LltpgXDd5gzMo4vDpLKhY6RhMF8xUDBOBgNVBAMM\nR9Cd0JXQk9CG0JfQk9CGINCa0KPTmNCb0JDQndCU0KvQoNCj0KjQqyDQntCg0KLQ\nkNCb0KvSmiAoR09TVCkgVEVTVCAyMDIyMQswCQYDVQQGEwJLWoIUJ9Ord5A3Lltp\ngXDd5gzMo4vDpLIwOQYDVR0gBDIwMDAuBgYqgw4DAQIwJDAiBggrBgEFBQcCARYW\naHR0cDovL3Jvb3QuZ292Lmt6L2NwczAOBgoqgw4DCgEBAgMCBQADgYEAmEN2bHz9\npAtI6X+P/2IQghWpYZZspmnFd/xBBnkMpKexT5HqlMFADm88PS49d3gPA4C2PaQG\nxs5NZooB08bcDRQVxNbok24UE+V0VjNGLh3sVTff11GM7E59MndeqTwxk248Pef1\n7a7EoTtWGoc5pBl3wMXxGvg4mxOcpD+N/BU=\n-----END CERTIFICATE-----",
    "-----BEGIN CERTIFICATE-----\nMIID/TCCA2WgAwIBAgIUetJLG6OgyWH+HKhQPmqiu0UNuKMwDgYKKoMOAwoBAQID\nAgUAMF8xUDBOBgNVBAMMR9Cd0JXQk9CG0JfQk9CGINCa0KPTmNCb0JDQndCU0KvQ\noNCj0KjQqyDQntCg0KLQkNCb0KvSmiAoR09TVCkgVEVTVCAyMDIyMQswCQYDVQQG\nEwJLWjAeFw0yMjA3MDcwOTU1MjNaFw0zMjA3MDQwOTU1MjNaMF0xTjBMBgNVBAMM\nRdKw0JvQotCi0KvSmiDQmtCj05jQm9CQ0J3QlNCr0KDQo9Co0Ksg0J7QoNCi0JDQ\nm9Cr0pogKEdPU1QpIFRFU1QgMjAyMjELMAkGA1UEBhMCS1owgawwIwYJKoMOAwoB\nAQICMBYGCiqDDgMKAQECAgEGCCqDDgMKAQMDA4GEAASBgLg6ffxI/sxPLaDh3hLs\nK8f9P7PMFjc56V21F+SDFKNkURgSXG93YnmPUuKv6NqP8flHGTFV+gpGiM4p3XPR\nbdE3sg0hQ8SaoHXR2h6hofM3OycgAFJHIBHDsrM5McqfgkuVVgnP/FnUkzmEG3/s\nC0Z9c7Ux27UsnudfeVvVEBhro4IBpzCCAaMwDwYDVR0TAQH/BAUwAwEB/zAOBgNV\nHQ8BAf8EBAMCAQYwOgYDVR0fBDMwMTAvoC2gK4YpaHR0cDovL2NybC5yb290Lmdv\ndi5rei9nb3N0X3Rlc3RfMjAyMi5jcmwwHQYDVR0OBBYEFPrSSxujoMlh/hyoUD5q\nortFDbijMIGcBgNVHSMEgZQwgZGAFKfTq3eQNy5baYFw3eYMzKOLw6SyoWOkYTBf\nMVAwTgYDVQQDDEfQndCV0JPQhtCX0JPQhiDQmtCj05jQm9CQ0J3QlNCr0KDQo9Co\n0Ksg0J7QoNCi0JDQm9Cr0pogKEdPU1QpIFRFU1QgMjAyMjELMAkGA1UEBhMCS1qC\nFCfTq3eQNy5baYFw3eYMzKOLw6SyMEsGCCsGAQUFBwEBBD8wPTA7BggrBgEFBQcw\nAoYvaHR0cDovL3Jvb3QuZ292Lmt6L2NlcnQvcm9vdF90ZXN0X2dvc3RfMjAyMi5j\nZXIwOQYDVR0gBDIwMDAuBgYqgw4DAwIwJDAiBggrBgEFBQcCARYWIGh0dHA6Ly9w\na2kuZ292Lmt6L2NwczAOBgoqgw4DCgEBAgMCBQADgYEAF1XLtw6Fcdzrl33J2DaP\n125p+nQviyEddDJxb0mUlxbWUTAZlKsAqphfN/SxEd2w0pJL39hTysG0rAC6Lp5b\ndMdmsclPZqdn22SqiCluNXUpTj84jh8hdT9QVB6Ll4yYlBf9WlZUFqzWF6oR151h\n1xL1D1wcq8c2SQpMUZFOKHU=\n-----END CERTIFICATE-----"
];

/**
 * serialNumber: "54878937544452191dc1fdd7f55524acf1540794",
 * pass Qwerty12
 */